module.exports = __webpack_public_path__ + "img/Anhänger_SwPu_25000.688ba187.svg";